module.exports = __webpack_public_path__ + "static/perempuan-c166bd53d810b65d63c5d5e61c3b43f4.png";